import React from "react";
import {
  BrowserRouter as Router,
  useLocation
} from "react-router-dom";

import { useEffect } from 'react';

import './App.css';

import googlelogo from './assets/img/google-logo.svg'
import ReactGA from "react-ga4";


// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Title() {
  let query = useQuery();
  let term = query.get("q") ?? "";
  return (
    <div className="row ">
      <div className="col-xs-12 text-center">
        <h3>{term}</h3>
      </div>
    </div>
  )

}

function GoogleLink(props) {
  let link = "https://google.com/search?q=" + props.term;
  return (
    <a href={link} className="list-group-item">
      <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
      <img src={googlelogo} alt="Google" />
    </a>
  )
}

function BiduLink(props) {
  let link = "https://www.baidu.com/s?wd=" + props.term;
  return (
    <a href={link} className="list-group-item">
      <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
      Baidu 百度
    </a>
  )
}


function Deliverys(props) {
  let term = props.term ?? "";
  var countrycode = props.countrycode ?? "";
  if (countrycode === "ja") {
    return (
      <div className="list-group">
        <a href={"http://jizen.kuronekoyamato.co.jp/jizen/servlet/crjz.b.NQ0010?id=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          クロネコヤマト（ヤマト運輸）
        </a>
        <a href={"http://k2k.sagawa-exp.co.jp/p/web/okurijosearch.do?okurijoNo=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          佐川急便
        </a>
        <a href={"http://tracking.post.japanpost.jp/service/singleSearch.do?org.apache.struts.taglib.html.TOKEN=&searchKind=S002&locale=ja&SVID=&reqCodeNo1=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          日本郵便
        </a>
        <a href={"https://lp-trace.nittsu.co.jp/web/webarpaa702.srv?LANG=JP&officeselect2=&denpyoNo1=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          日通ペリカン便 （日本通運）
        </a>

        <a href={"https://corp.fukutsu.co.jp/situation/tracking_no_hunt/" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          福山通運
        </a>

        <a href={"http://track.seino.co.jp/kamotsu/KamotsuPrintServlet?ACTION=LIST&GNPNO1=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          西濃運輸
        </a>

      </div>
    )
  } else {
    return (
      <div className="list-group">

        <a href={"http://www.fedex.com/Tracking?action=track&tracknumbers=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          Fedex
        </a>

        <a href={"https://tools.usps.com/go/TrackConfirmAction_input?qtc_tLabels1=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          USPS
        </a>


        <a href={"http://www.stamps.com/shipstatus/submit/?confirmation=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          Stamps
        </a>

        <a href={"http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          UPS
        </a>

        <a href={"http://www.lasership.com/track/LS" + term} className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          LaserShip
        </a>

        <a href={"https://www.dhl.com/en/express/tracking.html?brand=DHL&AWB=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          DHL US
        </a>

        <a href={"http://webtrack.dhlglobalmail.com/?trackingnumber=" + term} className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          DHL Global
        </a>

        {/*<a href={"http://www.ontrac.com/trackingdetail.asp?tracking=" + term} className="list-group-item">*/}
        {/*  <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>*/}
        {/*  OnTrac*/}
        {/*</a>*/}

        <a href={"http://iccworld.com/track.asp?txtawbno=" + term} className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          iccworld
        </a>

        <a href={"http://www.canadapost.ca/cpotools/apps/track/personal/findByTrackNumber?trackingNumber=" + term}
          className="list-group-item">
          <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>
          Canada Post
        </a>

        {/*<a href={"http://ipsweb.ptcmysore.gov.in/ipswebtracking/IPSWeb_item_events.asp?itemid=" + term}*/}
        {/*   className="list-group-item">*/}
        {/*  <span className="pull-right"> <i className="fas fa-chevron-right"></i> </span>*/}
        {/*  India Post*/}
        {/*</a>*/}

      </div>
    )
  }

}


function SearchLinks(props) {
  let term = props.term ?? "";
  var countrycode = props.countrycode ?? "";
  if (countrycode !== "zh") {
    return (<GoogleLink term={term} />)
  } else {
    return (<BiduLink term={term} />)
  }
}


// function Amazon(props) {
//   let useAmazonSearch = props.countrycode === "ja"

//   useEffect(() => {
//     if (!useAmazonSearch) return;
//     window.amzn_assoc_default_search_key = props.term

//     const script = document.createElement('script');

//     script.src = "//z-fe.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&Operation=GetScript&ID=OneJS&WS=1&Marketplace=JP";
//     script.async = true;

//     document.getElementById('amzonsearch').replaceWith(script);
//     // document.body.appendChild(script);
//     // document.getElementById('amzonsearch').appendChild(script);
//     //
//     // return () => {
//     //     document.getElementById('amzonsearch').removeChild(script);
//     // }
//   }, [props, useAmazonSearch]);

//
// let term = props.term ?? "";
// let type = props.type ?? "";
// var countrycode = props.countrycode ?? "";
// if (countrycode === "ja" && type==="EAN-13") {
//     return (
//         <div className="list-group-item list-group-item-amazon"></div>);
// }
// else{
//     return (<div />);
// }
//   if (useAmazonSearch) {

//     return (<div className="row ">
//       <div className="col-xs-12 text-center">

//         <div>
//           <div id="amzonsearch">
//             Amazon
//           </div>
//         </div>
//       </div>
//     </div>);
//   }
//   else {
//     return (<div></div>)
//   }

// }

function NumberLinks() {
  const location = useLocation();
  let query = useQuery();

  let term = query.get("q") ?? "";
  document.title = "Number Search " + term;

  let btype = query.get("t") ?? "";
 
  let lang = query.get("l") ?? "ja";
  var countrycode = "";
  if (lang.length >= 2) {
    countrycode = lang.substr(0, 2);
  }
  //  console.log("term=[%s] lang=[%s] countrycode=[%s]", term, lang, countrycode)


  useEffect(() => {
    console.log("location.pathname=[%s]", location.pathname);
    ReactGA.initialize("G-V26EF5WXFK");
    ReactGA.send({
      hitType: "pageview",
      page: `${location.pathname}`,
      title: `Number Search ${btype}`
    });
  }, [location]);

  return (
    <div className="row searchcontents">
      {/* <Amazon term={term} lang={lang} countrycode={countrycode} /> */}

      <SearchLinks term={term} lang={lang} countrycode={countrycode} />
      <Deliverys
        term={term}
        lang={lang}
        countrycode={countrycode}
      />
    </div>
  )
}

export default function App() {
  return (
    <Router>
      <Title />

      <NumberLinks />

    </Router>
  );
}

// export default App;
